import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ADMIN_API_SERVER_URL } from '../tokens/admin-api-server-url.token';
import { ServerBaseService } from '../server-base.service';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
import { CurrencyData } from '@equipmyschool/emsadminweb-models';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService extends ServerBaseService {
  private _id$ = new BehaviorSubject<number>(null);
  private id$ = this._id$.asObservable();
  private _currencies$ = new BehaviorSubject<CurrencyData[]>([]);
  
  public currencies$: Observable<CurrencyData[]> = this._currencies$.asObservable();
  public currency$: Observable<CurrencyData> = combineLatest([this.currencies$, this.id$]).pipe(map(([currencies, id]) => currencies.find(currency => currency.CurrencyID == id)));

  constructor(http: HttpClient, @Inject(ADMIN_API_SERVER_URL) serverUrl: string) {
    super(http, serverUrl)

    this.request<CurrencyData[]>('GET', 'Currency/Get').subscribe({
      next: (currencies => this._currencies$.next(currencies))
    });
  }

  public getCurrency(currencyId: number) {
    this._id$.next(currencyId);
  }
}
